import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const Carousel = ({
  children,
  responsiveConfig,
  sliderRef,
  infinite = true,
  fade = false,
  slideToShow = 4,
  autoplay = false,
  autoplaySpeed = 3000,
}) => {
  const defaultResponsive = [
    { breakpoint: 1024, settings: { slidesToShow: 3 } },
    { breakpoint: 768, settings: { slidesToShow: 2 } },
    { breakpoint: 480, settings: { slidesToShow: 1 } },
  ];

  const settings = {
    dots: false,
    infinite: infinite,
    speed: 560,
    slidesToShow: slideToShow,
    fade: fade,
    slidesToScroll: 1,
    centerMode: false,
    focusOnSelect: false,
    autoplay,
    autoplaySpeed,

    responsive: responsiveConfig || defaultResponsive,
  };

  return (
    <div className="relative">
      <Slider ref={sliderRef} {...settings} className="h-[100%]">
        {children}
      </Slider>
    </div>
  );
};

export default Carousel;
